"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashcamEmptyIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var DashcamEmptyIcon = function DashcamEmptyIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 61 60"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 17.5H48C52.1421 17.5 55.5 20.8579 55.5 25V35C55.5 39.1421 52.1421 42.5 48 42.5H13C8.85786 42.5 5.5 39.1421 5.5 35V25C5.5 20.8579 8.85786 17.5 13 17.5Z",
    stroke: "currentColor",
    strokeWidth: "5",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.5625 7.5H19.5625C20.9432 7.5 22.0625 8.61929 22.0625 10C22.0625 11.3807 20.9432 12.5 19.5625 12.5H9.5625C8.18179 12.5 7.0625 11.3807 7.0625 10C7.0625 8.61929 8.18179 7.5 9.5625 7.5Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.125 34.75C35.4326 34.75 33.25 32.5674 33.25 29.875C33.25 27.1826 35.4326 25 38.125 25C40.8174 25 43 27.1826 43 29.875C43 32.5674 40.8174 34.75 38.125 34.75Z",
    stroke: "currentColor",
    strokeWidth: "5",
    fill: "none"
  }));
};
exports.DashcamEmptyIcon = DashcamEmptyIcon;